import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable } from 'rxjs';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { DumbCompanyDetails } from './DTOs/dumb-company';
import { DumbCompanyAddress } from './DTOs/dumb-company-address';
import { DumbLiaison } from './DTOs/dumb-liaison';
import { AddEditMemberAddressModalComponent } from './modals/add-edit-address-modal.component';
import { EditCompanyInfoModalComponent } from './modals/edit-company-info-modal.component';
import { EditCompanyLiaisonComponent } from './modals/edit-company-liaison.component';
import { SuperAdminMemberManagementService } from './super-admin-member-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EditCompanyPaymentInfoModalComponent } from './modals/edit-company-payment-info-modal.component';
import { EditCompanyDirectoryInfoModalComponent } from './modals/edit-company-directory-info-modal.component';

@Component({
  selector: 'app-super-admin-member-details',
  templateUrl: './super-admin-member-details.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class SuperAdminMemberDetailsComponent {
    constructor(private membershipService: SuperAdminMemberManagementService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router) {
    }

    company: DumbCompanyDetails = {} as DumbCompanyDetails;
    liaison: DumbLiaison = {} as DumbLiaison;
    addresses: DumbCompanyAddress[] = [];
    memberId: string;

    ngOnInit() {
        this.memberId = this.route.snapshot.paramMap.get("id");
        this.blockUI.start();
        var observablesMerged = merge(this.getCompanyDetailsObservable());
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.company = data;
                    this.liaison = data.liaison;
                    this.addresses = data.addresses;
                },
                error: (err) => {
                    this.notificationService.error(err.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });
    }

    getCompanyDetailsObservable(): Observable<DumbCompanyDetails> {
        return this.membershipService
            .getCompanyDetails(this.memberId);
    }

    getCompanyDetails() {
        this.blockUI.start();

        this.getCompanyDetailsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.company = data;
                        this.liaison = data.liaison;
                        this.addresses = data.addresses;
                    },
                    error: (err) => {
                        this.notificationService.error(err.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    openEditCompanyInfoModal() {
        const modalRef = this.modalService.open(EditCompanyInfoModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.company = this.company;
        modalRef.componentInstance.memberId = this.memberId;
        modalRef.result.then(response => {
            //this.company = response;
            this.getCompanyDetails();
        })
            .catch(err => {

            }).finally();
    }

    openEditCompanyDirectoryInfoModal() {
        const modalRef = this.modalService.open(EditCompanyDirectoryInfoModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.company = this.company;
        modalRef.componentInstance.memberId = this.memberId;
        modalRef.result.then(response => {
            this.getCompanyDetails();
        })
            .catch(err => {

            }).finally();
    }

    openAddEditAddressInfoModal(adding: boolean, address: DumbCompanyAddress = null) {
        const modalRef = this.modalService.open(AddEditMemberAddressModalComponent, { size: 'lg', backdrop: 'static' });
        if (adding)
            address = new DumbCompanyAddress();
        modalRef.componentInstance.address = address;
        modalRef.componentInstance.adding = adding;
        modalRef.componentInstance.headerText = "Edit Address";
        modalRef.componentInstance.memberId = this.memberId;

        if (adding)
            modalRef.componentInstance.headerText = "Add Address";

        modalRef.result.then(response => {
            //address = response;
            this.getCompanyDetails();
        })
            .catch(err => {

            }).finally();
    }

    openEditLiaisonModal() {
        const modalRef = this.modalService.open(EditCompanyLiaisonComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.liaison = this.company.liaison;
        modalRef.componentInstance.memberId = this.memberId;

        modalRef.result.then(response => {
            //this.company.liaison = response;
            this.getCompanyDetails();
        })
            .catch(err => {

            }).finally();
    }

    openEditCompanyPaymentInfoModal() {
        const modalRef = this.modalService.open(EditCompanyPaymentInfoModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.company = this.company;
        modalRef.componentInstance.memberId = this.memberId;
        modalRef.result.then(response => {
            this.getCompanyDetails();
        })
            .catch(err => {
            }).finally();
    }
}
